<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-secondary-gradient greet-user h-100">
                    <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
                    <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
          <feather-icon icon="AwardIcon" class="p-6 mb-8 inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">Witaj {{ user && user.first_name ? `${user.first_name},` : '!' }}</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
            Przygotowane dla Ciebie szkolenia czekają w zakładce <strong>Szkolenia</strong>.
          </p>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 lg:w-1/6 mb-base">
        <vx-card slot="no-body" class="text-center h-100">
          <feather-icon icon="ClockIcon" class="p-4 mt-8 mb-4 inline-flex rounded-full bg-wod-green text-wod-green" svgClasses="h-6 w-6"></feather-icon>
          <h2 class="mb-6"><strong>{{ startedTrainings ? startedTrainings.length : '0'}}</strong></h2>
          <p class="mx-auto text-color-base">Rozpoczęte szkolenia</p>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 lg:w-1/6 mb-base">
        <vx-card slot="no-body" class="text-center h-100">
          <feather-icon icon="StarIcon" class="p-4 mt-8 mb-4 inline-flex rounded-full bg-wod-blue text-wod-blue" svgClasses="h-6 w-6"></feather-icon>
          <h2 class="mb-6"><strong>{{ completedTrainings ? completedTrainings.length : '0'}}</strong></h2>
          <p class="mx-auto text-color-base">Ukończone szkolenia</p>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 lg:w-1/6 mb-base">
        <vx-card slot="no-body" class="text-center h-100">
          <feather-icon icon="AwardIcon" class="p-4 mt-8 mb-4 inline-flex rounded-full bg-wod-yellow text-wod-orange" svgClasses="h-6 w-6"></feather-icon>
          <h2 class="mb-6"><strong>{{ completedTrainings ? completedTrainings.length : '0'}}</strong></h2>
          <p class="mx-auto text-color-base">Uzyskane certyfikaty</p>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="startedTrainings">
      <div class="vx-col w-full">
        <h4 class="my-3 text-color-base">Rozpoczęte skolenia:</h4>
      </div>
      <div class="vx-col w-full lg:w-1/3 mb-base" v-for="t in startedTrainings">
        <training-card :title="t.name" :description="t.description" :thumbnail="t.thumbnail_url" :uuid="t.uuid" />
      </div>
    </div>
  </div>
</template>

<script>

import notification from "@/notification"
import fetchUserTrainings from "@/mixins/elearning/fetchUserTrainings"
import TrainingCard from "@/components/wod/cards/TrainingCard"

export default {
  mixins: [fetchUserTrainings],
  components: {
    TrainingCard
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    startedTrainings: function() {
      return this.userTrainings && this.userTrainings.filter(x => x.is_started ).length > 0 ? this.userTrainings.filter(x => x.is_started ) : null
    },
    completedTrainings: function() {
      return this.userTrainings && this.userTrainings.filter(x => x.is_completed ).length > 0 ? this.userTrainings.filter(x => x.is_completed ) : null
    }
  },
  mounted () {
    this.getMe()
  },
  methods: {
    getMe(){
      this.$vs.loading()
      this.$store.dispatch('auth/getLoggedInUser')
        .then(() => {
          this.user = {...this.$store.state.auth.loggedInUser}
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
        .finally(()=>{
          this.$vs.loading.close()
        })
    }
  },
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
